import { type MRT_Localization } from "material-react-table";

export const MRT_Localization_OR: MRT_Localization = {
  language: "or",
  actions: "କାର୍ଯ୍ୟଗୁଡ଼ିକ",
  and: "ଏବଂ",
  cancel: "ବାତିଲ୍ କରନ୍ତୁ",
  changeFilterMode: "ଫିଲ୍ଟର ମୋଡ୍ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
  changeSearchMode: "ଖୋଜା ମୋଡ୍ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
  clearFilter: "ଫିଲ୍ଟର ସଫା କରନ୍ତୁ",
  clearSearch: "ଖୋଜା ସଫା କରନ୍ତୁ",
  clearSelection: "ବାଛିବା ସଫା କରନ୍ତୁ",
  clearSort: "ସର୍ଟିଂ ସଫା କରନ୍ତୁ",
  clickToCopy: "କପି କରିବା ପାଇଁ କ୍ଲିକ୍ କରନ୍ତୁ",
  copy: "କପି",
  collapse: "ସଙ୍କୁଚିତ କରନ୍ତୁ",
  collapseAll: "ସବୁ ସଙ୍କୁଚିତ କରନ୍ତୁ",
  columnActions: "କଲମ୍ କାର୍ଯ୍ୟଗୁଡ଼ିକ",
  copiedToClipboard: "କ୍ଲିପବୋର୍ଡରେ କପି ହୋଇଗଲା",
  dropToGroupBy: "ଗୃପ କରିବା ପାଇଁ {column} ରେ ଡ୍ରପ୍ କରନ୍ତୁ",
  edit: "ସମ୍ପାଦନ",
  expand: "ବିସ୍ତାର କରନ୍ତୁ",
  expandAll: "ସବୁ ବିସ୍ତାର କରନ୍ତୁ",
  filterArrIncludes: "ଅନ୍ତର୍ଭୁକ୍ତ କରେ",
  filterArrIncludesAll: "ସବୁ ଅନ୍ତର୍ଭୁକ୍ତ କରେ",
  filterArrIncludesSome: "ଅନ୍ତର୍ଭୁକ୍ତ କରେ",
  filterBetween: "ମଧ୍ୟରେ",
  filterBetweenInclusive: "ଅନ୍ତର୍ଭୁକ୍ତ ମଧ୍ୟରେ",
  filterByColumn: "{column} ଦ୍ୱାରା ଫିଲ୍ଟର୍ କରନ୍ତୁ",
  filterContains: "ଅନ୍ତର୍ଭୁକ୍ତ କରେ",
  filterEmpty: "ଖାଲି",
  filterEndsWith: "ସହିତ ଶେଷ ହୁଏ",
  filterEquals: "ସମାନ",
  filterEqualsString: "ସମାନ",
  filterFuzzy: "ଫଜି",
  filterGreaterThan: "ଠାରୁ ବଡ଼",
  filterGreaterThanOrEqualTo: "ଠାରୁ ବଡ଼ କିମ୍ବା ସମାନ",
  filterInNumberRange: "ମଧ୍ୟରେ",
  filterIncludesString: "ଅନ୍ତର୍ଭୁକ୍ତ କରେ",
  filterIncludesStringSensitive: "ଅନ୍ତର୍ଭୁକ୍ତ କରେ",
  filterLessThan: "ଠାରୁ ଛୋଟ",
  filterLessThanOrEqualTo: "ଠାରୁ ଛୋଟ କିମ୍ବା ସମାନ",
  filterMode: "ଫିଲ୍ଟର୍ ମୋଡ୍: {filterType}",
  filterNotEmpty: "ଖାଲି ନୁହେଁ",
  filterNotEquals: "ସମାନ ନୁହେଁ",
  filterStartsWith: "ସହିତ ଆରମ୍ଭ ହୁଏ",
  filterWeakEquals: "ସମାନ",
  filteringByColumn: "{column} ଦ୍ୱାରା ଫିଲ୍ଟରିଂ - {filterType} {filterValue}",
  goToFirstPage: "ପ୍ରଥମ ପୃଷ୍ଠାକୁ ଯାଆନ୍ତୁ",
  goToLastPage: "ଶେଷ ପୃଷ୍ଠାକୁ ଯାଆନ୍ତୁ",
  goToNextPage: "ପରବର୍ତ୍ତୀ ପୃଷ୍ଠାକୁ ଯାଆନ୍ତୁ",
  goToPreviousPage: "ପୂର୍ବବର୍ତ୍ତୀ ପୃଷ୍ଠାକୁ ଯାଆନ୍ତୁ",
  grab: "ଧରନ୍ତୁ",
  groupByColumn: "{column} ଦ୍ୱାରା ଗୃପ କରନ୍ତୁ",
  groupedBy: "ଦ୍ୱାରା ଗୃପ ହୋଇଛି ",
  hideAll: "ସବୁ ଲୁଚାନ୍ତୁ",
  hideColumn: "{column} କଲମ୍ ଲୁଚାନ୍ତୁ",
  max: "ସର୍ବାଧିକ",
  min: "ସର୍ବନିମ୍ନ",
  move: "ସ୍ଥାନାନ୍ତର କରନ୍ତୁ",
  noRecordsToDisplay: "ଦେଖାଇବା ପାଇଁ କୌଣସି ରେକର୍ଡ୍ ନାହିଁ",
  noResultsFound: "କୌଣସି ଫଳାଫଳ ମିଳିଲା ନାହିଁ",
  of: "ର",
  or: "କିମ୍ବା",
  pin: "ପିନ୍ କରନ୍ତୁ",
  pinToLeft: "ବାମକୁ ପିନ୍ କରନ୍ତୁ",
  pinToRight: "ଡାହାଣକୁ ପିନ୍ କରନ୍ତୁ",
  resetColumnSize: "କଲମ୍ ଆକାର ରିସେଟ୍ କରନ୍ତୁ",
  resetOrder: "କ୍ରମ ରିସେଟ୍ କରନ୍ତୁ",
  rowActions: "ଧାଡି କାର୍ଯ୍ୟଗୁଡ଼ିକ",
  rowNumber: "#",
  rowNumbers: "ଧାଡି ସଂଖ୍ୟାଗୁଡ଼ିକ",
  rowsPerPage: "ପ୍ରତି ପୃଷ୍ଠାରେ ଧାଡିଗୁଡ଼ିକ",
  save: "ସେଭ୍ କରନ୍ତୁ",
  search: "ଖୋଜନ୍ତୁ",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} ରୁ {rowCount} ଧାଡି(ଗୁଡ଼ିକ) ବାଛିଛି",
  select: "ବାଛନ୍ତୁ",
  showAll: "ସବୁ ଦେଖାନ୍ତୁ",
  showAllColumns: "ସବୁ କଲମ୍ ଦେଖାନ୍ତୁ",
  showHideColumns: "କଲମ୍ ଦେଖାନ୍ତୁ/ଲୁଚାନ୍ତୁ",
  showHideFilters: "ଫିଲ୍ଟର୍ ଦେଖାନ୍ତୁ/ଲୁଚାନ୍ତୁ",
  showHideSearch: "ଖୋଜା ଦେଖାନ୍ତୁ/ଲୁଚାନ୍ତୁ",
  sortByColumnAsc: "{column} ଦ୍ୱାରା ଆରୋହୀ କ୍ରମରେ ସର୍ଟ୍ କରନ୍ତୁ",
  sortByColumnDesc: "{column} ଦ୍ୱାରା ଅବରୋହୀ କ୍ରମରେ ସର୍ଟ୍ କରନ୍ତୁ",
  sortedByColumnAsc: "{column} ଦ୍ୱାରା ଆରୋହୀ କ୍ରମରେ ସର୍ଟ୍ ହୋଇଛି",
  sortedByColumnDesc: "{column} ଦ୍ୱାରା ଅବରୋହୀ କ୍ରମରେ ସର୍ଟ୍ ହୋଇଛି",
  thenBy: ", ତା'ପରେ ",
  toggleDensity: "ଘନତା ଟୋଗଲ୍ କରନ୍ତୁ",
  toggleFullScreen: "ପୂର୍ଣ୍ଣ ସ୍କ୍ରିନ୍ ଟୋଗଲ୍ କରନ୍ତୁ",
  toggleSelectAll: "ସବୁ ବାଛିବା ଟୋଗଲ୍ କରନ୍ତୁ",
  toggleSelectRow: "ଧାଡି ବାଛିବା ଟୋଗଲ୍ କରନ୍ତୁ",
  toggleVisibility: "ଦୃଶ୍ୟତା ଟୋଗଲ୍ କରନ୍ତୁ",
  ungroupByColumn: "{column} ଦ୍ୱାରା ଗୃପ ବାତିଲ୍ କରନ୍ତୁ",
  unpin: "ଅନପିନ୍ କରନ୍ତୁ",
  unpinAll: "ସବୁ ଅନପିନ୍ କରନ୍ତୁ",
};
